<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <!-- ── Page Header ─────────────────────────────────────── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center p-t-40 p-b-40" style="gap: 20px;">
            <img
              :src="`https://claimify-api.hayokmedicare.ng/image/${client.user.user_image}`"
              class="header-avatar"
              onerror="this.onerror=null; this.src='/assets/img/ohis_logo.png'"
            />
            <div class="text-white">
              <h2 class="page-title mb-1" v-clipboard="client.user.firstname">
                {{ client.user.firstname }} {{ client.user.lastname }}
              </h2>
              <div class="d-flex align-items-center flex-wrap" style="gap: 8px; margin-top: 6px;">
                <span class="header-id-badge">
                  <i class="fe fe-credit-card mr-1"></i>{{ client.user.id_card_number }}
                </span>
                <span v-if="client.user.status == 'active'" class="header-status header-status--active">
                  <i class="fe fe-check-circle mr-1"></i> Active
                </span>
                <span v-else-if="client.user.status == 'inactive'" class="header-status header-status--inactive">
                  <i class="fe fe-alert-circle mr-1"></i> Inactive
                </span>
                <span v-if="client.user.sector" class="header-id-badge">
                  <i class="fe fe-layers mr-1"></i>{{ client.user.sector }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <!-- ── Action Bar (employee / shis only) ──────────────── -->
        <div class="card action-card shadow mb-4" v-if="user.type == 'employee' || user.type == 'shis'">
          <div class="card-body py-3 px-4">
            <div class="d-flex flex-wrap align-items-center" style="gap: 8px;">

              <button class="btn btn-sm btn-outline-primary" @click="startCamera" data-toggle="modal"
                data-target="#example_01">
                <i class="fe fe-camera mr-1"></i> Take Photo
              </button>

              <label class="btn btn-sm btn-outline-secondary mb-0" style="cursor: pointer;">
                <i class="fe fe-upload mr-1"></i> Upload Picture
                <input type="file" accept="image/*" style="display:none;" v-on:change="attachPic" />
              </label>

              <a :href="`/enrollee_slip/${$route.params.id}`" class="btn btn-sm btn-outline-info">
                <i class="fe fe-file mr-1"></i> Enrollee Slip
              </a>

              <router-link :to="{ path: '/patient/' + $route.params.id }">
                <button class="btn btn-sm btn-outline-info">
                  <i class="mdi mdi-medical-bag mr-1"></i> Medical
                </button>
              </router-link>

              <router-link :to="{ path: '/add-dependent/' + $route.params.id }" v-if="user.type != 'provider_employee'">
                <button class="btn btn-sm btn-outline-info">
                  <i class="fe fe-users mr-1"></i> Dependents
                </button>
              </router-link>

              <router-link :to="{ path: '/edit-user/' + $route.params.id }" v-if="user.type != 'provider_employee'">
                <button class="btn btn-sm btn-outline-dark">
                  <i class="fe fe-edit mr-1"></i> Edit
                </button>
              </router-link>

              <button @click="printMe" class="btn btn-sm btn-outline-secondary">
                <i class="fe fe-printer mr-1"></i> Print
              </button>

              <!-- More dropdown -->
              <div class="dropdown ml-auto">
                <button type="button" class="btn btn-sm btn-outline-secondary dropdown-toggle"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fe fe-more-horizontal mr-1"></i> More
                </button>
                <div class="dropdown-menu dropdown-menu-right" style="min-width: 200px;">
                  <div class="dropdown-item" role="button" v-if="user.user_role != 0"
                    data-toggle="modal" data-target="#exampleModal">
                    <i class="mdi mdi-credit-card mr-2 text-info"></i> Add Payment
                  </div>
                  <div class="dropdown-item" role="button" @click="changeNumber">
                    <i class="fe fe-hash mr-2 text-info"></i> Generate ID
                  </div>
                  <div class="dropdown-divider"></div>
                  <div class="dropdown-item text-danger" role="button" @click="markAsDead">
                    <i class="fe fe-alert-triangle mr-2"></i> Mark as Dead
                  </div>
                  <div class="dropdown-item text-danger" role="button" @click="deleteUser" v-if="user.user_role == 1">
                    <i class="fe fe-trash-2 mr-2"></i> Delete
                  </div>
                </div>
              </div>

            </div>
          </div>

          <!-- Payment Modal -->
          <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content" style="border-radius:12px; overflow:hidden;">
                <div class="modal-header" style="background: linear-gradient(135deg,#1e3a5f,#2563eb);">
                  <h5 class="modal-title text-white" id="exampleModalLabel">
                    <i class="mdi mdi-credit-card mr-2"></i>Add Payment
                  </h5>
                  <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="form-group">
                    <label class="small font-weight-bold text-muted text-uppercase">Amount</label>
                    <input type="number" placeholder="Enter Amount" class="form-control" v-model="userPayment.amount" />
                  </div>
                  <div class="form-group">
                    <label class="small font-weight-bold text-muted text-uppercase">Payment Proof</label>
                    <div class="fileinput fileinput-new" data-provides="fileinput">
                      <span class="btn btn-outline-secondary btn-sm btn-file">
                        <span class="fileinput-new"><i class="fe fe-upload mr-1"></i> Upload Proof</span>
                        <span class="fileinput-exists">Change</span>
                        <input type="file" accept="image/png, image/gif, image/jpeg" name="..."
                          multiple v-on:change="attachPaymentProof" />
                      </span>
                      <span class="fileinput-filename ml-2"></span>
                      <a href="#" class="close fileinput-exists" data-dismiss="fileinput" style="float:none">&times;</a>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Cancel</button>
                  <button type="button" class="btn btn-primary" data-dismiss="modal" @click="addPayment">
                    <i class="fe fe-send mr-1"></i> Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- End Payment Modal -->

        </div>

        <!-- ── Main Content ────────────────────────────────────── -->
        <div class="row">

          <!-- Left column: printable ID card -->
          <div class="col-lg-8 col-md-12">

            <div id="printDiv" ref="printNow">
              <div class="card shadow-sm mb-4 profile-card" style="
                  background-image: url('../assets/img/ohis_transparent.png');
                  background-size: cover;
                  background-repeat: no-repeat;
                ">
                <div class="profile-card-header">
                  <div class="row spacer-top w-100">
                    <div class="col-md-2">
                      <span class="avatar avatar-xl">
                        <img src="/assets/img/ohis_logo.png" class="rounded-circle" />
                      </span>
                    </div>
                    <div class="col-md-8">
                      <strong>
                        <h2 class="h3 text-success text-center">
                          RIVERS STATE CONTRIBUTORY HEALTH PROTECTION PROGRAMME
                        </h2>
                      </strong>
                      <strong>
                        <p class="h2 text-center">(RIVCHPP)</p>
                      </strong>
                    </div>
                    <div class="col-md-2">
                      <qrcode-vue :value="`https://rivchpp.web.app/verify-user/${$route.params.id}`" :size="80"
                        :level="'H'" render-as="svg"></qrcode-vue>
                    </div>
                  </div>
                </div>

                <div class="card-body row">
                  <div class="col-md-4">
                    <img :src="`https://claimify-api.hayokmedicare.ng/image/${client.user.user_image}`" class="img rounded"
                      alt="User Photo" onerror="this.onerror=null; this.src='/assets/img/ohis_logo.png'" />
                  </div>

                  <div class="col-md-8">
                    <p class="h3 spacer-top-bottom">
                      <strong class="text-primary">NAME :</strong>
                      <strong>{{ client.user.lastname }}</strong>
                      {{ client.user.firstname }}, {{ client.user.middlename }}
                    </p>
                    <hr />
                    <p class="h3 spacer-top-bottom">
                      <strong class="text-primary">ID NUMBER:</strong>
                      <strong>{{ client.user.id_card_number }}</strong>
                    </p>
                    <hr />
                    <p class="h3 spacer-top-bottom">
                      <strong class="text-primary">EXPIRY DATE:</strong>
                      <strong>{{ client.user.expiry_date | moment("dddd, MMMM Do YYYY") }}</strong>
                    </p>
                    <hr />
                    <p class="h3 spacer-top-bottom">
                      <strong class="text-primary">FACILITY TO ACCESS CARE:</strong>
                      <strong v-if="client.provider != null">{{ client.provider.agency_name }}</strong>
                    </p>
                    <hr />
                    <p class="h3 spacer-top-bottom" v-if="client.user.place_of_work != null">
                      <strong class="text-primary">MDA:</strong>
                      <strong> {{ client.user.place_of_work }}</strong>
                    </p>
                    <hr />
                    <p class="h3 spacer-top-bottom">
                      <strong class="text-primary">Plan Type:</strong>
                      <strong>Individual</strong>
                    </p>
                    <hr />
                    <p class="h3 spacer-top-bottom">
                      <strong class="text-primary">SECTOR:</strong>
                      <strong> {{ client.user.sector }}</strong>
                    </p>
                    <hr />
                  </div>
                </div>
              </div>

              <div class="card print-back-card">
                <EnrolleeCardBack :verify-url="`https://rivchpp.web.app/verify-user/${$route.params.id}`" />
              </div>
            </div>

            <!-- Transactions -->
            <div class="card table-card shadow mb-4">
              <div class="card-body pb-0">
                <p class="h5 mb-0">
                  <i class="fe fe-credit-card mr-1"></i>
                  <strong>{{ client.transactions.length }} Transactions</strong>
                </p>
              </div>
              <div class="table-responsive">
                <table class="table align-td-middle mb-0">
                  <thead class="table-head">
                    <tr>
                      <th class="table-th">S/N</th>
                      <th class="table-th">Transaction Type</th>
                      <th class="table-th">Transaction Amount</th>
                      <th class="table-th">Transaction Proof</th>
                      <th class="table-th">Description</th>
                      <th class="table-th">Date Created</th>
                      <th class="table-th">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="table-row" v-for="(trx, index) in client.transactions" v-bind:key="trx.id">
                      <td>{{ index + 1 }}</td>
                      <td>{{ trx.type }}</td>
                      <td>&#8358;{{ trx.amount | numeral(0, 0) }}</td>
                      <td>
                        <button class="btn btn-sm btn-outline-info" v-if="trx.type == 'offline'" @click="gotoTrxImage(trx)">
                          view proof
                        </button>
                      </td>
                      <td>{{ trx.description }}</td>
                      <td>{{ trx.created_at | moment("dddd, MMMM Do YYYY") }}</td>
                      <td>
                        <button class="btn btn-sm btn-outline-danger" name="button" @click="deleteTrx(trx)">
                          <i class="fe fe-trash-2"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-body pt-3" v-show="trx_image">
                <img :src="`https://claimify-api.hayokmedicare.ng/documents/${trx_doc.document}`" class="img-responsive"
                  v-if="trx_doc != null" />
              </div>
            </div>

          </div>

          <!-- Right sidebar -->
          <div class="col-lg-4 col-md-12">
            <div class="card shadow-sm" style="border-radius: 14px; border: none;">
              <div class="card-header border-0 pt-4 pb-2 px-4"
                style="background: #f8f9fa; border-radius: 14px 14px 0 0;">
                <h6 class="mb-0 font-weight-bold text-dark">
                  <i class="fe fe-info text-primary mr-2"></i>Additional Details
                </h6>
              </div>
              <div class="card-body p-0">
                <ul class="list-group list-group-flush">
                  <li class="info-row">
                    <i class="fe fe-calendar info-icon"></i>
                    <div>
                      <p class="info-label">Date Enrolled</p>
                      <p class="info-value">{{ client.user.created_at | moment("MMM Do YYYY") }}</p>
                    </div>
                  </li>
                  <li class="info-row" v-for="(dep, index) in dependents" :key="dep.id">
                    <i class="fe fe-users info-icon"></i>
                    <div>
                      <p class="info-label">Dependent {{ index + 1 }}</p>
                      <p class="info-value">{{ dep.firstname }} {{ dep.lastname }}</p>
                    </div>
                  </li>
                  <li class="info-row" v-if="client.enrolled_by != null">
                    <i class="fe fe-user-check info-icon"></i>
                    <div>
                      <p class="info-label">Enrolled By</p>
                      <p class="info-value">{{ client.enrolled_by.full_name }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-hash info-icon"></i>
                    <div>
                      <p class="info-label">NIMC Number</p>
                      <p class="info-value">{{ client.user.nimc_number || '—' }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-credit-card info-icon"></i>
                    <div>
                      <p class="info-label">Virtual Account Number</p>
                      <p class="info-value">{{ client.user.virtual_account || '—' }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-user info-icon"></i>
                    <div>
                      <p class="info-label">Gender</p>
                      <p class="info-value">{{ client.user.gender }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-phone info-icon"></i>
                    <div>
                      <p class="info-label">Phone Number</p>
                      <p class="info-value">{{ client.user.phone_number }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-map-pin info-icon"></i>
                    <div>
                      <p class="info-label">LGA / Ward</p>
                      <p class="info-value">
                        <span v-if="client.local_government != null">{{ client.local_government.local_name }}</span>
                        /
                        <span v-if="client.ward != null">{{ client.ward.ward_name }}</span>
                      </p>
                    </div>
                  </li>

                   <li class="info-row" v-if="client.community != null">
                    <i class="fe fe-home info-icon"></i>
                    <div>
                      <p class="info-label">Community</p>
                      <p class="info-value">{{ client.community.name || '—' }}</p>
                    </div>
                  </li>


                  <li class="info-row">
                    <i class="fe fe-gift info-icon"></i>
                    <div>
                      <p class="info-label">Date of Birth</p>
                      <p class="info-value">{{ client.user.dob | moment("D/M/YYYY") }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-mail info-icon"></i>
                    <div>
                      <p class="info-label">Email</p>
                      <p class="info-value">{{ client.user.email || '—' }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-tool info-icon"></i>
                    <div>
                      <p class="info-label">Occupation</p>
                      <p class="info-value">{{ client.user.occupation || '—' }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-book info-icon"></i>
                    <div>
                      <p class="info-label">Education</p>
                      <p class="info-value">{{ client.user.education || '—' }}</p>
                    </div>
                  </li>
                 
                  <li class="info-row">
                    <i class="fe fe-calendar info-icon"></i>
                    <div>
                      <p class="info-label">Expiry Date</p>
                      <p class="info-value">{{ client.user.expiry_date || '—' }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-smile info-icon"></i>
                    <div>
                      <p class="info-label">Marital Status</p>
                      <p class="info-value">{{ client.user.marital_status || '—' }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-briefcase info-icon"></i>
                    <div>
                      <p class="info-label">MDA</p>
                      <p class="info-value">{{ client.user.place_of_work || '—' }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-tag info-icon"></i>
                    <div>
                      <p class="info-label">Staff ID</p>
                      <p class="info-value">{{ client.user.salary_number || '—' }}</p>
                    </div>
                  </li>
                  <li class="info-row" v-if="client.user.category_of_vulnerable_group">
                    <i class="fe fe-users info-icon"></i>
                    <div>
                      <p class="info-label">Vulnerable Group</p>
                      <p class="info-value">{{ client.user.category_of_vulnerable_group }}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Modal for Camera capture -->
      <div class="modal fade" id="example_01" tabindex="-1" role="dialog" aria-labelledby="example_02"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="container-fluid">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <div class="row">
                <div class="col-md-12 p-t-20 p-b-20">
                  <video id="video" width="100%" height="auto" autoplay></video>
                  <p class="mt-4">
                    <button @click="takePic" class="bg-navy btn btn-flat">
                      Snap Photo
                    </button>
                  </p>
                  <canvas id="canvas" width="750px" height="400px"></canvas>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal Ends -->

      <div class="vld-parent">
        <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
      </div>
      <PhotoCropper ref="photoCropper" />
    </main>
  </section>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";
  import PhotoCropper from "@/components/PhotoCropper.vue";
  import EnrolleeCardBack from "@/views/clients/components/EnrolleeCardBack.vue";
  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  // Init plugin
  import QRCodeVue from "qrcode.vue";

  export default {
    components: { PhotoCropper,
      Navbar,
      EnrolleeCardBack,
      Loading,
      qrcodeVue: QRCodeVue,
    },
    data() {
      return {
        user: null,
        trx_image: false,
        auth_user: "",
        client: { user: "full_name", transactions: [] },
        trx_doc: null,
        notes: "",
        dependents: "",
        medications: "",
        healthFacility: "",
        signature: "",
        enrolled_by: "",
        singleward: "",
        singlelga: "",
        edit: false,
        isLoading: false,
        fullPage: true,
        transactionID: "",
        agency_id: "",
        imagefile: "",
        image: "",
        paymentProofFile: "",
        paymentProofImage: "",
        output: "",
        singletpa: "",
        trxdocclass: "col-md-4",
        trxtableclass: "col-md-12",
        pictureShower: true,
        userPayment: {
          description: "",
          amount: "",
        },
        transaction_ref_length: 50,
        video_settings: {
          video: {
            width: {
              min: 1280,
              ideal: 1920,
              max: 2560,
            },
            height: {
              min: 720,
              ideal: 1080,
              max: 1440,
            },
            facingMode: "environment",
          },
        },
        services: [
          {
            drug: "",
            service: "",
            type: "Drug",
            dose: 1,
            frequency: 1,
            days: 1,
          },
        ],
      };
    },
    mounted() {
      this.print();
    },

    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/user/zam/${this.$route.params.id}`)
        .then((response) => {
          this.client = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    computed: {
      randomTransId() {
        var result = "";
        var characters =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var charactersLength = characters.length;
        for (var i = 0; i < this.transaction_ref_length; i++) {
          result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
          );
        }
        console.log({ result });
        return result;
      },
    },

    methods: {
      async startCamera() {
        var video = document.getElementById("video");
        // Get access to the camera!
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          // Not adding `{ audio: true }` since we only want video now
          navigator.mediaDevices
            .getUserMedia(this.video_settings)
            .then(function (stream) {
              //video.src = window.URL.createObjectURL(stream);
              video.srcObject = stream;
              video.play();
            });
        }
      },
      addPayment() {
        if (confirm("Are you sure you want to Submit?")) {
          this.isLoading = true;
          this.axios
            .post(`/api/v1/make/transaction`, {
              user_id: this.$route.params.id,
              agency_id: 407465,
              description: `This payment is made by ${this.user.full_name} with ID of ${this.user.id}`,
              amount: this.userPayment.amount,
              type: "offline",
              status: "approved",
              transaction_ref: this.randomTransId,
            })
            .then((response) => {
              this.transactionID = response.data.id;

              this.isLoading = false;
              this.$toasted.success("Payment Added Successfully", {
                position: "top-center",
                duration: 3000,
              });
              this.fetchUser();
            })
            .catch((error) => {
              console.error(error);
              this.isLoading = false;
            });

          this.userPayment.description = "";
          this.userPayment.amount = "";
        }

        setTimeout(() => {
          this.uploadPaymentProof();
        }, 3000);
      },

      changeNumber() {
        this.isLoading = true;
        this.axios
          .patch(`/api/v1/auth/id-card-number/change/${this.$route.params.id}`)
          .then((response) => {
            console.log(response);
            this.$toasted.success("Changed Successfully", {
              position: "top-center",
              duration: 3000,
            });
            this.isLoading = false;
            this.fetchUser();
          })
          .catch((error) => {
            console.error(error);
            this.$toasted.error("Error!", {
              position: "top-center",
              duration: 3000,
            });
            this.isLoading = false;
          });
      },
      // User picture upload: crop first, then save through uploadcustomerpicImage
      attachPic(event) {
        const file = event.target.files[0];
        event.target.value = "";
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (e) => this.cropAndSavePic(e.target.result);
        reader.readAsDataURL(file);
      },

      attachPaymentProof(event) {
        this.user = JSON.parse(localStorage.getItem("user"));
        console.log(event);
        this.paymentProofFile = event.target.files[0];
        console.log(this.paymentProofFile);
      },

      uploadPaymentProof() {
        this.isLoading = true;
        this.user = JSON.parse(localStorage.getItem("user"));

        var formData = new FormData();
        formData.append("transaction_id", this.transactionID);
        formData.append("user_id", this.$route.params.id);
        formData.append("document", this.paymentProofFile);

        this.axios
          .post("/api/v1/auth/uploadTransactionDocument", formData)
          .then((response) => {
            this.paymentProofImage = response.data.document;
            console.log(response.data.document);
            this.isLoading = false;
            this.$toasted.success("Payment Added Successfully", {
              position: "top-center",
              duration: 3000,
            });
            this.fetchUser();
          });
      },

      async print() {
        const el = this.$refs.printNow;

        const options = {
          type: "dataURL",
        };
        this.output = await this.$html2canvas(el, options);
      },
      streamPic() {
        console.log("hello pic");

        var video = document.getElementById("video");
        // Get access to the camera!
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          // Not adding `{ audio: true }` since we only want video now
          navigator.mediaDevices
            .getUserMedia(this.video_settings)
            .then(function (stream) {
              //video.src = window.URL.createObjectURL(stream);
              video.srcObject = stream;
              video.play();
            });
        }
      },
      printMe() {
        var printContents = document.getElementById("printDiv").innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
      },
      attachSign(event) {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.signature = event.target.files[0];
        console.log(event);
        this.uploadSign();
      },

      authUser() {
        this.axios
          .get(`/api/v1/auth/user`)
          .then((response) => {
            this.auth_user = response.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      takePic() {
        var video = document.getElementById("video");
        var canvas = document.getElementById("canvas");
        var context = canvas.getContext("2d");

        context.drawImage(video, 0, 0, 640, 480);
        // close the camera dialog, then crop the snapshot and save it
        // eslint-disable-next-line no-undef
        $("#example_01").modal("hide");
        this.cropAndSavePic(canvas.toDataURL("image/jpeg"));
      },

      async cropAndSavePic(src) {
        const cropped = await this.$refs.photoCropper.open(src);
        if (cropped) this.savePic(cropped);
      },

      savePic(image) {
        this.isLoading = true;
        this.axios
          .post(`/api/v1/auth/uploadcustomerpicImage`, {
            user_image: image,
            user_id: this.$route.params.id,
          })
          .then((response) => {
            console.log(response);
            this.$toasted.success("uploaded Successfully", {
              position: "top-center",
              duration: 3000,
            });
            this.fetchUser();
            this.isLoading = false;
          })
          .catch((error) => {
            console.error(error);
            this.isLoading = false;
          });
      },
      deleteUser() {
        if (confirm("Are you Sure you want to delete this user")) {
          this.axios
            .delete(`/api/v1/auth/deleteUser/${this.$route.params.id}`)
            .then((response) => {
              console.log(response);
              this.$toasted.success("Deleted Successfully", {
                position: "top-center",
                duration: 3000,
              });
              this.$router.push("/view-clients-agency");
            })
            .catch((error) => {
              console.error(error);
            });
        }
      },

      markAsDead() {
        if (confirm("Are you sure you want to mark this enrollee as dead?")) {
          this.user = JSON.parse(localStorage.getItem("user"));
          this.isLoading = true;

          this.axios
            .post("/api/v1/auth/addHealthRecord", {
              provider_id: this.client.user.provider_id,
              patient_id: this.$route.params.id,
              dependent_id: null,
              reasonVisit: "Marked as dead",
              testResult: "N/A",
              agency_id: 407465,
              drVisited: this.user.id,
              professional_id: this.user.id,
              notes: "Client marked as dead.",
              diagnosis: 0,
              secondary_diagnosis: null,
              encounter_outcome: "Death",
              phone_number: this.client.user.phone_number,
              patient_type: "Outpatient",
              medications: "death",
              documents: "death",
              treatment_type: "Primary",
              date_of_admission: null,
              date_of_discharge: null,
              date_of_visit: new Date().toISOString().split("T")[0],
            })
            .then((response) => {
              console.log(response);
              return this.axios.delete(
                `/api/v1/auth/deleteUser/${this.$route.params.id}`
              );
            })
            .then((response) => {
              console.log(response);
              this.isLoading = false;
              this.$toasted.success(
                "Health record created and enrollee deleted successfully.",
                {
                  position: "top-center",
                  duration: 3000,
                }
              );
              this.$router.push("/view-clients-agency");
            })
            .catch((error) => {
              console.log(error.response);
              this.isLoading = false;
              this.$toasted.error("Unable to complete mark as dead and delete.", {
                position: "top-center",
                duration: 3000,
              });
            });
        }
      },

      deleteTrx(trx) {
        if (confirm("Are you Sure you want to delete?")) {
          this.axios
            .delete(`/api/v1/auth/delete/transaction/${trx.id}`)
            .then((response) => {
              console.log(response);
              this.fetchUser();
              this.$toasted.success("Deleted Successfully", {
                position: "top-center",
                duration: 3000,
              });
            })
            .catch((error) => {
              console.error(error);
            });
        }
      },
      gotoTrxImage(trx) {
        this.axios
          .get(`/api/v1/auth/get/transaction-document/${trx.id}`)
          .then((response) => {
            console.log(response);
            this.$toasted.success("Gotten Successfully", {
              position: "top-center",
              duration: 3000,
            });
            this.trx_doc = response.data.data;
            this.trx_image = true;
            this.trxtableclass = "col-md-8";
          })
          .catch((error) => {
            console.error(error);
          });
      },

      fetchUser() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/user/zam/${this.$route.params.id}`)
          .then((response) => {
            this.client = response.data;
            this.dependents = response.data.dependents;

            //get dependents
            this.axios
              .post(`/api/v1/auth/allDependantsUser`, {
                agency_id: 407465,
                id_card_number: this.client.id_card_number,
                user_id: this.$route.params.id,
              })
              .then((response) => {
                let answers = response.data;
                answers;
                console.log(response);
              })
              .catch((error) => {
                console.error(error);
              });
            //end of get dependents
          })
          .catch((error) => {
            console.error(error);
          });
      },

      uploadPic() {
        this.isLoading = true;
        let snap = localStorage.getItem("snap");

        var formData = new FormData();
        formData.append("user_image", snap);
        this.axios
          .post("/api/v1/auth/uploadUserImage", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            this.$breadstick.notify("Profile Image changed Successfully!", {
              position: "top-right",
            });
          });
      },
    },
    created() {
      this.startCamera();
      this.fetchUser();
    },
  };
</script>
<style scoped>
  /* ── Page Header ─────────────────────────────────────── */
  .page-header {
    background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
    padding-bottom: 60px;
  }

  .page-title {
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 0;
    cursor: pointer;
  }

  .header-avatar {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    object-fit: cover;
    border: 3px solid rgba(255, 255, 255, 0.4);
    flex-shrink: 0;
  }

  .header-id-badge {
    display: inline-flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.18);
    color: #fff;
    font-size: 0.78rem;
    padding: 3px 10px;
    border-radius: 20px;
    font-weight: 500;
  }

  .header-status {
    display: inline-flex;
    align-items: center;
    font-size: 0.78rem;
    padding: 3px 10px;
    border-radius: 20px;
    font-weight: 600;
  }

  .header-status--active {
    background: rgba(16, 185, 129, 0.25);
    color: #6ee7b7;
  }

  .header-status--inactive {
    background: rgba(245, 158, 11, 0.25);
    color: #fcd34d;
  }

  /* ── Action Card ─────────────────────────────────────── */
  .action-card {
    border-radius: 14px;
    border: none;
  }

  /* ── Profile / ID card ───────────────────────────────── */
  .profile-card {
    border-radius: 14px;
    border: none;
    overflow: hidden;
  }

  .profile-card-header {
    display: flex;
    align-items: center;
    padding: 20px 24px;
    border-bottom: 1px solid #f1f5f9;
    background: rgba(255,255,255,.85);
  }

  /* ── Info Rows ───────────────────────────────────────── */
  .info-row {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 20px;
    list-style: none;
    border-bottom: 1px solid #f1f5f9;
  }

  .info-row:last-child {
    border-bottom: none;
  }

  .info-icon {
    color: #2563eb;
    font-size: 0.95rem;
    margin-top: 2px;
    flex-shrink: 0;
  }

  .info-label {
    font-size: 0.7rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #94a3b8;
    margin-bottom: 1px;
    font-weight: 600;
  }

  .info-value {
    font-weight: 600;
    color: #1e293b;
    font-size: 0.9rem;
    margin-bottom: 0;
  }

  /* ── Legacy / kept ───────────────────────────────────── */
  .spacer {
    margin-left: 1px;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .spacer-image {
    margin-top: 25px;
  }

  .spacer-top-bottom {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .spacer-top {
    margin-top: 50px;
  }

  #container {
    margin: 0px auto;
    width: 500px;
    height: 375px;
    border: 10px #333 solid;
  }

  #videoElement {
    width: 500px;
    height: 375px;
    background-color: #666;
  }

  th {
    text-align: center;
  }

  td {
    width: fit-content;
    text-align: center;
  }

  .payment__proof {
    width: 20%;
  }

  .payment__proof,
  svg,
  video,
  canvas,
  audio,
  iframe,
  embed,
  object {
    display: inline-block;
  }

  .print-back-card {
    display: none;
  }

  @media print {
    .print-back-card {
      display: block;
    }
  }
</style>
